import React from 'react';

export const EmailSentIcon = () => (
  <svg
    width="289"
    height="121"
    viewBox="0 0 289 121"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M71.5361 20.625L288.786 0L111.411 36.4375L71.5361 20.625Z"
      fill="#E6F0FD"
    />
    <path
      d="M112.099 78.375L119.661 45.7188L288.442 0.34375L112.099 78.375Z"
      fill="#1A5ADE"
    />
    <path
      d="M111.411 36.4375L112.099 78.375L119.661 45.7188L288.786 0L111.411 36.4375Z"
      fill="#4B91F5"
    />
    <path
      d="M119.661 45.7188L288.786 0C250.401 36.4375 167.786 121 167.786 121L119.661 45.7188Z"
      fill="#E6F0FD"
    />
    <path
      d="M99.3657 82.591C86.3985 82.591 73.0324 82.591 65.2521 97.5531C59.4014 108.804 43.1081 110.72 37.1233 111.318"
      stroke="#C3DAFB"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M88.5929 61.0455C75.6257 61.0455 55.6762 61.6439 45.502 76.606C32.5553 95.6453 13.7823 97.553 1.21411 96.9545"
      stroke="#C3DAFB"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M111.934 103.642C103.555 101.773 98.4079 103.522 94.5776 110.225"
      stroke="#C3DAFB"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
